// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".object-includer.query .field-group .field-ctn {\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
